export default {
  contributions: (state) => {
    return state.contributions;
  },
  siteType: (state) => {
    return state.siteType;
  },
  toolbarSearchText: (state) => {
    return state.toolbarSearchText
  }
};
